
import React from 'react';
import { Link } from 'react-router-dom';
import { allNews } from '../../data/newsData';

const article = allNews.find(item => item.id === 2);

const DetailedNews2Page: React.FC = () => {
    if (!article) {
        return <div>Article not found</div>;
    }

    return (
        <div className="pt-20 bg-gray-50 min-h-screen">
            <header className="bg-white py-16 text-center border-b">
                 <div className="container mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-[#3aabd2]">News</h1>
                    <p className="mt-2 text-lg text-gray-600">お知らせ</p>
                </div>
            </header>
            <section className="py-20">
                <div className="container mx-auto px-6 max-w-4xl">
                    <article className="bg-white p-8 md:p-12 rounded-lg shadow-lg border border-gray-200">
                        {article.img && <img src={article.img} alt={article.title} className="w-full h-auto max-h-96 object-cover rounded-lg mb-8 shadow-md" />}
                        <p className="text-sm text-gray-500 mb-2">{article.date}</p>
                        <h1 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-8 pb-4 border-b border-gray-200">{article.title}</h1>
                        <div 
                            className="prose lg:prose-lg max-w-none text-gray-700 leading-relaxed"
                            dangerouslySetInnerHTML={{ __html: article.content }}
                        >
                        </div>
                    </article>
                    <div className="text-center mt-12">
                        <Link to="/news" className="inline-flex items-center justify-center py-3 px-8 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-[#3aabd2] hover:bg-[#2f8faf] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3aabd2] transition-all duration-300">
                            ニュース一覧に戻る
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default DetailedNews2Page;